import { render, staticRenderFns } from "./BuscarCliente.vue?vue&type=template&id=bc21f758"
import script from "./BuscarCliente.vue?vue&type=script&lang=js"
export * from "./BuscarCliente.vue?vue&type=script&lang=js"
import style0 from "./BuscarCliente.vue?vue&type=style&index=0&id=bc21f758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports